export const SEARCH_FAILED_STATEMENT =
  '<span class="text-danger">Your search could not be completed. Please try running it again from the search form.</span>';

// Failed loads return no statement of their own.
export function statementFor(error, queryStatement) {
  return error ? SEARCH_FAILED_STATEMENT : queryStatement;
}
